/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 4/18/16.
 */

'use strict';

angular.module('prism-ui.package').service('DownloadAssetService', function (
    this: JS5Object,
    $q: JS5Object,
    AuthFactory: JS5Object,
    DebugService: JS5Object,
    EndPointService: JS5Object,
    InventoryResourceFactory: JS5Object,
    ProxyResourceFactory: JS5Object,
    UtilsService: JS5Object
) {
    enum AssetType {
        Video = 'video',
        VideoClip = 'video_clip',
        Clip = 'clip',
        Image = 'image',
        Audio = 'audio',
        Document = 'document'
    }
    this.AssetType = AssetType;

    enum ContentUse {
        Source = 'source',
        Proxy = 'proxy'
    }
    this.ContentUse = ContentUse;

    // use Lodash to memoize/cache server-provided asset URIs
    const getUriCacheKey = (id: string, assetType: string, contentUse: string) => `${assetType.length},${contentUse.length},${id}${assetType}${contentUse}`;

    const loadAssetUriPromise = (id: string, assetType: string, contentUse: string) => {
        DebugService.debug(`loading ${contentUse} URI for ${assetType} with id ${id}`);
        return InventoryResourceFactory.getAssetUri({assetType, contentUse, id}).$promise
            .then((uriData: JS5Object) => {
                if (uriData.uri.includes(':')) {
                    return uriData;
                }
                return {uri: `${EndPointService.mediaAssetEndpoint}?assetType=${assetType}&assetId=${id}&contentUse=${contentUse}&${AuthFactory.getAuthQueryString()}`};
            })
            .catch((errorData: any) => {
                // discard this promise from the cache
                this.getAssetUri.cache.delete(getUriCacheKey(id, assetType, contentUse));
                console.error(`caught error loading URI`);
                return $q.reject(errorData);
            });
    };

    this.getAssetUri = _.memoize(loadAssetUriPromise, getUriCacheKey);

    this.downloadAsset = (id: string, downloadFileName: string, assetType: string, contentUse: string) => {
        return this.getAssetUri(id, assetType, contentUse)
            .then((uriObj: JS5Object) => {
                DebugService.debug(`downloading ${downloadFileName} from ${uriObj.uri}`);
                return UtilsService.downloadFile(uriObj.uri, downloadFileName);
            });
    };

});
